import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import AgentsService from "services/admin/AgentsService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import _ from "lodash";
import withRouter from "hoc/withRouter";
import { useEffect } from "react";

const LLMModels = [
  {
    value: "gpt-4o-mini",
    name: "GPT-4o-mini",
  },
  {
    value: "gpt-4o",
    name: "GPT-4o",
  },
  {
    value: "gpt-4",
    name: "GPT-4",
  },
];

const timeZones = [
  {
    value: "Asia/Almaty",
    name: "Алматы",
  },
  {
    value: "Asia/Shanghai",
    name: "Шанхай",
  },
];

const statuses = [
  {
    value: "ACTIVE",
    name: "Активный",
  },
  {
    value: "INACTIVE",
    name: "Неактивный",
  },
  {
    value: "DRAFT",
    name: "Черновик",
  },
];
/**
 * responseTimeout - время ожидания ответа от агента в секундах
 * temperature - температура генерации
 * @param param0
 * @returns
 */
const AgentForm = ({
  data: { agent },
  router: {
    params: { id },
  },
}: any) => {
  console.log("agent: ", agent);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    reset,
    control,
  } = useForm({
    defaultValues: {
      name: _.get(agent, "name", ""),
      description: _.get(agent, "description", ""),
      status: _.get(agent, "status", "ACTIVE"),
      llmModel: _.get(agent, "llmModel", "gpt-4o-mini"),
      timeZone: _.get(agent, "timeZone", "Asia/Almaty"),
      temperature: _.get(agent, "temperature", 0.5),
      responseTimeout: _.get(agent, "responseTimeout", 10),
    },
    mode: "onChange",
  });

  useEffect(() => {
    console.log("resetting form", id, agent);
    reset({
      name: _.get(agent, "name", ""),
      description: _.get(agent, "description", ""),
      status: _.get(agent, "status", "ACTIVE"),
      llmModel: _.get(agent, "llmModel", "gpt-4o-mini"),
      timeZone: _.get(agent, "timeZone", "Asia/Almaty"),
      temperature: _.get(agent, "temperature", 0.5),
      responseTimeout: _.get(agent, "responseTimeout", 10),
    });
  }, [agent]);

  const onSubmit = async (data: any) => {
    try {
      if (agent) {
        await AgentsService.put(agent.id, data);
        toast.success("Агент обновлен успешно!");
      } else {
        await AgentsService.post(data);
        toast.success("Агент создан успешно!");
      }
      setTimeout(() => {
        navigate("/admin/ai-agents");
      }, 1500);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteAgent = async () => {
    try {
      if (!agent) {
        toast.error("Агент не найден!");
        return;
      }
      if (window.confirm("Вы уверены, что хотите удалить агента?")) {
        await AgentsService.delete(agent.id);
        toast.success("Агент удален успешно!");
        navigate(-1);
      }
    } catch (error) {
      toast.error("Ошибка при удалении агента!");
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h3 className="mb-8">{agent ? "Редактирование агента" : "Создание агента"}</h3>
      <div className="mb-4">
        <TextField
          label="Название агента"
          {...register("name", { required: true })}
          className="w-100 mb-4"
        />
      </div>
      <div className="mb-4">
        <TextField
          rows={3}
          multiline
          label="Описание агента"
          {...register("description")}
          className="w-100 mb-4"
        />
      </div>
      <div className="mb-4">
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel>Статус</InputLabel>
              <Select label="Статус" {...field} className="w-100 mb-4">
                {statuses.map((s) => (
                  <MenuItem key={s.value} value={s.value}>
                    {s.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </div>
      {/* <div className="mb-4">
        <Controller
          name="llmModel"
          control={control}
          render={({ field }) => {
            return (
              <FormControl fullWidth>
                <InputLabel>LLM модель</InputLabel>
                <Select label="LLM модель" {...field} className="w-100 mb-4">
                  {LLMModels.map((model) => (
                    <MenuItem key={model.value} value={model.value}>
                      {model.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }}
        ></Controller>
      </div> */}
      <div className="mb-4">
        <Controller
          name="timeZone"
          control={control}
          render={({ field }) => {
            return (
              <FormControl fullWidth>
                <InputLabel>TimeZone</InputLabel>
                <Select label="TimeZone" {...field} className="w-100 mb-4">
                  {timeZones.map((timeZone) => (
                    <MenuItem key={timeZone.value} value={timeZone.value}>
                      {timeZone.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }}
        ></Controller>
      </div>
      <div className="mb-4">
        <TextField
          label="Время ожидания ответа (в секундах)"
          {...register("responseTimeout")}
          type="number"
          className="w-100 mb-4"
          inputProps={{
            min: 0,
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">секунд</InputAdornment>,
          }}
        />
      </div>
      <div className="mb-4">
        <TextField
          label="Температура генерации (0.0 - 1.0)"
          {...register("temperature")}
          type="number"
          className="w-100 mb-4"
          inputProps={{
            min: 0,
            max: 1,
            step: 0.1,
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">0.0 - 1.0</InputAdornment>,
          }}
        />
      </div>
      <div className="w-100 flex gap-4">
        <Button variant="contained" color="primary" type="submit" disabled={!isValid}>
          Сохранить
        </Button>
        {agent && (
          <Button variant="outlined" color="error" type="button" onClick={() => deleteAgent()}>
            Удалить агента
          </Button>
        )}
      </div>
      {/* <pre>{JSON.stringify(watch(), null, 4)}</pre> */}
    </form>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(AgentForm, (router: any) => {
    let requests: any = {};
    console.log("router: ", router.params.id);
    if (router.params.id) {
      requests["agent"] = () => AgentsService.get(router.params.id);
    }
    return useLoadAll(requests, [router.params.id]);
  })
);
